export default __webpack_public_path__ + "static/media/Spectral-Medium.541f011f.ttf";